// removed by extract-text-webpack-plugin
module.exports = {"campaign-segment-option":"campaign-segment-option---fSMuK","DeliveryTimeFrame":"DeliveryTimeFrame---XDhVO","Disclaimer":"Disclaimer---1LMRt","TargetingAudience":"TargetingAudience---1ovUf","EmailFallBackDaysInput":"EmailFallBackDaysInput---2To-Y"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/CampaignWizards/TargetingInputArea/style.styl
// module id = Niip
// module chunks = 89